import React from "react";
import ChargingNetworkContainer from "../containers/ChargingNetworks/index";

const ChargingNetworksPage = () => {
  return (
    <>
      <ChargingNetworkContainer />
    </>
  );
};

export default ChargingNetworksPage;
